import TabComponent from '../../../components/navComponents/TabComponent';
import {
  useDashboardStore,
  useDashboardDispatch,
} from '../../../contexts/single-dashboard/DashboardContext';
import { useUpdateDashboard } from '../../../apiCalls/dashboards';
import { useBannerDispatch } from '../../../contexts/BannerContext';

export default function DashboardTab() {
  const { editedDashboard } = useDashboardStore();
  const { updateDashboard } = useUpdateDashboard();
  const dashboardDispatch = useDashboardDispatch();
  const bannerDispatch = useBannerDispatch();

  const handleTitleChange = async (newTitle) => {
    try {
      let updatedDash = { ...editedDashboard, title: newTitle };
      const returnDash = await updateDashboard({
        id: editedDashboard.id,
        title: newTitle,
      });
      if (returnDash?.id) {
        dashboardDispatch({ type: 'setEditedDashboard', payload: updatedDash });
      } else {
        const subText =
          returnDash?.message ||
          'An unexpected error occurred while saving the dashboard name.';
        bannerDispatch({
          type: 'changeBannerState',
          payload: {
            mainText: 'Error Saving Dashboard Name',
            subText,
            tallBanner: true,
            success: false,
          },
        });
      }
    } catch (error) {
      console.error('Error updating dashboard name:', error);
      bannerDispatch({
        type: 'changeBannerState',
        payload: {
          mainText: 'Error Saving Dashboard Name',
          subText: 'A network error occurred. Please try again.',
          tallBanner: true,
          success: false,
        },
      });
    }
  };

  return (
    <TabComponent
      key="dashboard"
      title={editedDashboard.title}
      classType={'Dashboard'}
      handleTitleChange={handleTitleChange}
    />
  );
}
